(($) => {

    let $tabLinks;

    $(document).on('ready', init);

    function init() {
        $tabLinks = $('.tablist--toc .tab__link');
        bind();
    }

    function bind() {
        $tabLinks.on('click', onTabLinkClick);
    }

    function onTabLinkClick(event) {
        if (!event) {
            return false;
        }

        let $link = $(event.target);

        $link.closest('.tab__container').find('.tab__link').each(function() {
            $(this).removeClass('active'); 
        });

        $link.addClass('active');
    }
})(jQuery);
